<div class="container-point">
  <lib-question-hint 
    class="question-hint" 
    [class.d-none]="!showMarkers"
    [hint]="'SLIDES.select_correct_answer' | translate">
  </lib-question-hint>

  <lib-hotspots-widget
    [hotspots]="data?.hotspots"
    [id]="data.id"
    [layout]="markerLayout"
    [langcode]="data?.langcode"
    [spacing]="data?.spacing"
    [bundle]="data?.type"
    [selectedHash]="selectedHash"
    (spotClick)="onSpotClick($event)">
  </lib-hotspots-widget>
</div>
